interface ShowPasswordProps {
    showPassword: boolean,
    setShowPassword: (showPassword: boolean) => void,
    inputId: string
}

export const ShowPassword = ({ showPassword, setShowPassword, inputId }: ShowPasswordProps) => {
    return (
        <div style={{ display: 'flex', gap: '4px', marginTop: '8px', fontSize: '13px' }}>
            <input
                type="checkbox"
                id={inputId}
                name={inputId}
                checked={showPassword}
                onChange={() => setShowPassword(!showPassword)}
            />
            <label htmlFor={inputId} className="cursor-pointer">
                Mostrar contraseña
            </label>
        </div>
    )
}
